import Divider from 'components/custom/Divider'
import { Text } from 'components/primitives'

export default function TokenDescription({
  description,
}: {
  description: string
}) {
  return (
    <>
      <Divider style={{ marginTop: 24 }} />
      <Text
        style="body1"
        css={{
          py: '$3',
          px: '$3',
          '@md': {
            px: 0,
          },
          wordBreak: 'break-word',
        }}
      >
        {description}
      </Text>
      <Divider />
    </>
  )
}
